import { useEffect, useState } from "react";

export function useLocalStorageState(key, defaultValue) {
    const [value, setValue] = useState(() => {
        try {
            const saved = window.localStorage.getItem(key);
            return saved !== null ? JSON.parse(saved) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // ignore write errors
        }
    }, [key, value]);

    return [value, setValue];
}
